/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataRocketWarehouseResVo } from './PageDataRocketWarehouseResVo';
import {
    PageDataRocketWarehouseResVoFromJSON,
    PageDataRocketWarehouseResVoFromJSONTyped,
    PageDataRocketWarehouseResVoToJSON,
    PageDataRocketWarehouseResVoToJSONTyped,
} from './PageDataRocketWarehouseResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataRocketWarehouseResVo
 */
export interface ResponsePageDataRocketWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataRocketWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataRocketWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataRocketWarehouseResVo}
     * @memberof ResponsePageDataRocketWarehouseResVo
     */
    data?: PageDataRocketWarehouseResVo;
}

/**
 * Check if a given object implements the ResponsePageDataRocketWarehouseResVo interface.
 */
export function instanceOfResponsePageDataRocketWarehouseResVo(value: object): value is ResponsePageDataRocketWarehouseResVo {
    return true;
}

export function ResponsePageDataRocketWarehouseResVoFromJSON(json: any): ResponsePageDataRocketWarehouseResVo {
    return ResponsePageDataRocketWarehouseResVoFromJSONTyped(json, false);
}

export function ResponsePageDataRocketWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataRocketWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataRocketWarehouseResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataRocketWarehouseResVoToJSON(json: any): ResponsePageDataRocketWarehouseResVo {
    return ResponsePageDataRocketWarehouseResVoToJSONTyped(json, false);
}

export function ResponsePageDataRocketWarehouseResVoToJSONTyped(value?: ResponsePageDataRocketWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataRocketWarehouseResVoToJSON(value['data']),
    };
}

